<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.tote_containers.hasTabToShow" class="tab" data-cy="tab-tote_containers">
              <h2 [className]="tabs.tote_containers.active? 'active': ''" (click)="tabs.tote_containers.activate()">{{tabs.tote_containers.title}}</h2>
            </div>
            <div *ngIf="tabs.tote_container_types.hasTabToShow" class="tab" data-cy="tab-tote_container_types">
              <h2 [className]="tabs.tote_container_types.active? 'active': ''" (click)="tabs.tote_container_types.activate()">{{tabs.tote_container_types.title}}</h2>
            </div>
            <div *ngIf="tabs.tote_statuses.hasTabToShow" class="tab" data-cy="tab-tote_statuses">
              <h2 [className]="tabs.tote_statuses.active? 'active': ''" (click)="tabs.tote_statuses.activate()">{{tabs.tote_statuses.title}}</h2>
            </div>
          </div>
        
              <Totes-tote_containers_grid *ngIf="tabs.tote_containers.active"
              #$tabs_tote_containers
              ($refreshEvent)="refresh(false, false, '$tabs_tote_containers')">
              </Totes-tote_containers_grid>
              <Totes-tote_types_grid *ngIf="tabs.tote_container_types.active"
              #$tabs_tote_container_types
              ($refreshEvent)="refresh(false, false, '$tabs_tote_container_types')">
              </Totes-tote_types_grid>
              <Totes-tote_container_statuses_grid *ngIf="tabs.tote_statuses.active"
              #$tabs_tote_statuses
              ($refreshEvent)="refresh(false, false, '$tabs_tote_statuses')">
              </Totes-tote_container_statuses_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>